import GenericException from '@/modules/shared/exceptions/GenericException'

export default class BaseHTTPError<Data> extends GenericException<Data> {
  constructor(info: {
    message: string
    cause?: unknown
    stack?: string
    data?: Data
    httpCode: number
    action: string
    name: string
  }) {
    super({
      name: info.name,
      message: info.message,
      action: info.action,
      cause: info.cause,
      stack: info.stack,
      data: info?.data
    })

    this.httpCode = info.httpCode
  }

  httpCode: number
}
